/** @file Kind markers drawn before hierarchy and asset rows (symbols, not words: nothing to translate). */

/** One glyph per row kind; `shown` / `hidden` mark whether a slot's setup attachment is that placeholder. */
export const ROW_BADGES = { bone: '◇', socket: '⊕', slot: '▭', shown: '●', hidden: '○', image: '▣', region: '▢', mesh: '△' } as const;
